module.exports = __webpack_public_path__ + "static/media/smiley-o-svgrepo-com.b3ac4d39.svg";